export type SupaSQBuilding = {
  buildingName: string;
  address_subpremise: string;
  address_street_number: string;
  address_route: string;
  address_locality: string;
  address_administrative_area_level_1: string;
  address_postal_code: string;
  place_id: string;
  geometry_location_lat: string;
  geometry_location_long: string;
  networkNodeId: string;
  numUnits?: string;
};

export type SupaSQUnit = {
  rid: string;
  ontid?: string;
  statusCode: '300' | '301' | '302';
  statusDescription: string;
  buildingName: string;
  unitNo: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postcode: string;
  networkNodeId?: string;
  remoteId?: string;  // BUID — used as IPoE RADIUS username
  serviceID?: string;
  networkTechnology?: string;
  unitType?: string;
  ipoeEnabled?: string;
  circuitId?: string;
};

export type SupaSQResponse = {
  status: 'success' | 'failed';
  statusCode: '200' | '401' | '402';
  description: string;
  servicedBuilding: SupaSQBuilding[] | null;
  buildingUnits: SupaSQUnit[] | null;
};

/**
 * A single building's place_id is not unique — Supa returns the same Google place_id
 * for every dwelling in a townhouse/estate development sharing one street entrance.
 * buildingName is what actually distinguishes rows, so key on both together.
 */
export function supaBuildingKey(b: SupaSQBuilding): string {
  return `${b.place_id ?? ''}|${b.buildingName}`;
}
